export const ANIMATION_TIMINGS = {
    PAGE_TRANSITION: 250,
    UPLOAD_TRANSITION: 400,
    WEBVIEW_TRANSITION: 400,
    WEBVIEW_CONTENT_TRANSITION: 250,
};

export const COLORS = {
    BLACK: '#000000',
    BLACK_COD: '#1C1C1C',
    GRAY_CADET: '#B1BBC7',
    GRAY_GALLERY: '#EAEAEA',
    GRAY_CHARCOAL: '#212B35',
    GRAY_MERCURY: '#E7E7E7',
    GRAY_NOBEL: '#B3B3B3',
    GRAY_TUNDORA: '#424242',
    GRAY_SCARPA: '#55555D',
    PURPLE_PLUM: '#92278F',
    WHITE: '#FFFFFF',
};

export const DISPLAY_STYLE = {
    BUTTON: 'button',
    TAB: 'tab',
};

// This styling is used to eliminate auto-zooming on iOS devices without changing the calculated font-size
// The styling uses a scale ratio between the current font-size and the expected minimum font-size (16px) by iOS devices
export const IOS_SCALE_STYLING = {
    THIRTEEN_PIXELS: {
        fontSize: '16px',
        transform: 'scale(0.8125)',
        transformOrigin: 'left',
        width: 'calc(100% / 0.8125)',
    },
    FOURTEEN_PIXELS: {
        fontSize: '16px',
        transform: 'scale(0.875)',
        transformOrigin: 'left',
        width: 'calc(100% / 0.875)',
    },
};
